import { render, staticRenderFns } from "./IndexViewMobile.vue?vue&type=template&id=6b5bcfea&scoped=true"
import script from "./IndexViewMobile.vue?vue&type=script&lang=js"
export * from "./IndexViewMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5bcfea",
  null
  
)

export default component.exports